module.exports = __webpack_public_path__ + "img/suspend.85201bf2.svg";